module.exports = __webpack_public_path__ + "img/successlq.6c9a5e43.svg";